import React, { useState, useEffect } from "react";
import { Box, MenuItem, Menu, useMediaQuery, IconButton, Badge } from "@mui/material";
import styles from "../../assets/css/modules/navbar.module.css";
import { Link, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handleLogout } from "../../redux/reducers/authReducer";
import styled from "styled-components";
import Searchbar from "./Searchbar";
import MobileLayout from "./MobileLayout";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import axiosInstance from "../../helpers/AxiosInstance";
import Popover from "@mui/material/Popover";
import { ButtonsContainer, Notification } from "../utilities";
import Translation from "../utilities/Translation";
import { useLocation } from "react-router-dom";
const NavbarBtn = styled(Link)`
  color: white;
  background: #f2a900;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 12px;
  padding: 10px 18px;
  min-width: 120px;
  height: 44px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px 0 rgba(242, 169, 0, 0.4);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 7px 20px 0 rgba(242, 169, 0, 0.5);
    filter: brightness(1.1);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 520px;
  min-width: 300px;
  height: 480px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
  border-radius: 20px;
  overflow: hidden;

  @media (max-width: 1440px) {
    width: 400px;
  }
  @media (max-width: 425px) {
    min-width: 300px;
  }
`;

const Line = styled.hr`
  border: none;
  height: 1px;
  background: #f2a900;
  margin: 10px 0;
`;

const Button = styled(Link)`
  min-width: 162px;
  height: 50px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  display: grid;
  place-items: center;
  text-align: center;
  font-weight: 700;
  font-family: Cairo;
  font-size: 18px;
  letter-spacing: 0px;
  color: #1e293b;
  text-decoration: none;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(148, 163, 184, 0.2);

  &:hover {
    background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(148, 163, 184, 0.2);
  }

  @media (max-width: 1440px) {
    font-size: 18px;
  }
`;

export default function Navbar({ sideOpen, setSideOpen, RoleID }) {
  const { pathname } = useLocation();
  const { t } = useTranslation("layout");
  const matches = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [anchor, setAnchor] = useState(null);
  const openNotification = Boolean(anchor);
  const openTranslation = Boolean(anchor);
  const handleNotificationClick = (event) => {
    setAnchor(event.currentTarget);
  };
  const [notifications, setNotifications] = useState([]);
  const instance = axiosInstance();
  const { data } = useQuery(
    "notifications",
    async () => {
      const { data } = await instance.get("/GetActiveNotifications");
      return data;
    },
    {
      staleTime: 60000,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (data) {
      setNotifications(data.notifications);
    }
  }, [data]);

  const { CompanyName, Logo } = useSelector((state) => ({
    CompanyName: state.Auth.companyData.CompanyName,
    Logo:
      state.Auth.companyData.Logo ||
      `https://ahmedaglan.github.io/ClientsJSON/ClientImages/${
        state.Auth.companyData.ClientID || "999999"
      }/logo.png`,
  }));
  const { ClientName, Username, AccountNo, UserID, SessionID, SunAccountName, SubAccountID, SubAccountName } = useSelector((state) => ({
    ClientName: state.Auth.AuthedUser.ClientName,
    Username: state.Auth.AuthedUser.Username,
    AccountNo: state.Auth.AuthedUser.AccountNo,
    UserID: state.Auth.AuthedUser.UserID,
    SessionID: state.Auth.AuthedUser.SessionID,
    SunAccountName: state.Auth.AuthedUser.SunAccountName,
    SubAccountID: state.Auth.AuthedUser.SubAccountID,
    SubAccountName: state.Auth.AuthedUser.SubAccountName,
  }));
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleLogoutClick = () => {
    dispatch(handleLogout());
  };
  if (matches) {
    return <MobileLayout RoleID={RoleID} />;
  }
  return (
    <div className={styles.navbar}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "70px",
          padding: "0 24px",
          background: "white",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        {/* Left side - Profile Avatar */}
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            alignItems: "center",
          }}
        >
          <Box
            onClick={handleClick}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                transform: "scale(1.05)",
                "& .avatar-box": {
                  boxShadow: "0 8px 25px rgba(242, 169, 0, 0.3)",
                  border: "2px solid #f2a900",
                },
              },
            }}
          >
            <Box
              className="avatar-box"
              sx={{
                width: 44,
                height: 44,
                borderRadius: "16px",
                background: "#f2a900",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 15px rgba(242, 169, 0, 0.2)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                border: "2px solid transparent",
              }}
            >
              <svg
                viewBox="0 0 24 24"
                width="22"
                height="22"
                stroke="white"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </Box>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#64748b"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{
                marginInlineStart: 8,
                transition: "transform 0.3s ease",
              }}
              className="dropdown-arrow"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </Box>
          
          {/* User Info Display */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              ml: 2,
              "@media (max-width: 1060px)": {
                display: "none",
              },
            }}
          >
            <Box
              sx={{ fontWeight: 700, fontSize: "16px", color: "#1e293b" }}
            >
             {Username}
            </Box>
          </Box>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            sx={{ zIndex: 1500 }}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 8px 32px rgba(0,0,0,0.15))",
                mt: 1.5,
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(20px)",
                border: "1px solid rgba(255, 255, 255, 0.18)",
                borderRadius: "16px",
                minWidth: "200px",
                zIndex: 1500,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  mr: 1,
                },
                "& .MuiMenuItem-root": {
                  borderRadius: "8px",
                  mx: 1,
                  my: 0.5,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={handleLogoutClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "7px",
              }}
            >
              <Box sx={{ fontSize: ".70em" }}>{t("Navbar.signout")}</Box>
            </MenuItem>
            <MenuItem
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "7px",
              }}
              component={NavLink}
              to="/change-password"
            >
              <Box sx={{ fontSize: ".70em" }}>
                {t("Navbar.change_password")}
              </Box>
            </MenuItem>
          </Menu>
        </Box>

        {/* Right side - Search, Notifications */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          {/* Extra spacing */}
          <Box sx={{ width: "20px" }} />

          {RoleID === 2 && (
            <IconButton
              style={{ background: "transparent" }}
              onClick={handleNotificationClick}
              sx={{
                background: "transparent",
                position: "relative",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  transform: "scale(1.1)",
                  "& .notification-icon": {
                    color: "#f2a900",
                    filter: "drop-shadow(0 0 8px rgba(242, 169, 0, 0.4))",
                  },
                },
              }}
            >
              <Badge
                badgeContent={notifications.length}
                color="error"
                overlap="circular"
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize: "10px",
                    fontWeight: "bold",
                    minWidth: "18px",
                    height: "18px",
                    padding: "0 4px",
                    boxShadow: "0 2px 8px rgba(239, 68, 68, 0.4)",
                  },
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="notification-icon"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
              </Badge>
            </IconButton>
          )}
          {/* ======================================================================================== */}
          <Translation />
          <Box>
            {!pathname.includes("cshome") && <Searchbar RoleID={RoleID} />}
          </Box>
        </Box>
        {RoleID === 2 && (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <NavbarBtn to="/new-shipment">
                {t("Navbar.add_shipment")}
              </NavbarBtn>
              <NavbarBtn to="/new-pickup">{t("Navbar.add_pickup")}</NavbarBtn>
              <NavbarBtn to="/upload">{t("Navbar.upload_excel")}</NavbarBtn>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    "@media (max-width: 1060px)": {
                      display: "none",
                    },
                  }}
                >
                  <Box
                    sx={{ fontWeight: 700, fontSize: "14px", color: "#1e293b" }}
                  >
                    {ClientName}
                  </Box>
                  <Box sx={{ fontSize: "12px", color: "#64748b" }}>
                    {SubAccountName ? SubAccountName : "pdc"}
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: "50%",
                    border: "3px solid #f1f5f9",
                    padding: "3px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    background: "#f2a900",
                    boxShadow: "0 4px 15px rgba(242, 169, 0, 0.2)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: "0 8px 25px rgba(242, 169, 0, 0.3)",
                      border: "3px solid #f2a900",
                    },
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "50%",
                    }}
                    src={Logo}
                  />
                </Box>
              </Box>
            </Box>
          </>
        )}
      </Box>

      {/* ============================================================= */}
      <Popover
        open={openNotification}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        onClick={() => {
          setAnchor(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ fontFamily: "Cairo" }}
      >
        <Card>
          <div dir="rtl">
            {notifications.slice(0, 3).map((notification, index) => (
              <Notification
                key={index}
                setNotifications={setNotifications}
                notifications={notifications}
                notificationIndex={index}
                AWB={notification.AWB}
                Body={notification.Body}
                Status={notification.StatusName}
                Serial={notification.Serial}
                Title={notification.Title}
              />
            ))}
            <Line />
            {notifications.length ? (
              <ButtonsContainer
                style={{ marginTop: "10px", marginBottom: "10px" }}
              >
                <Button to="/notifications" onClick={() => setAnchor(null)}>
                  {t("Navbar.all_notifications")}
                </Button>
              </ButtonsContainer>
            ) : (
              <ButtonsContainer
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  fontSize: "18px",
                }}
              >
                {t("Navbar.no_Notification")}
              </ButtonsContainer>
            )}
          </div>
        </Card>
      </Popover>
    </div>
  );
}
